import i18n from '../i18n';

export default (group, status) => {
  return i18n.t(`${group}.${status}`, { ns: 'enum' });
};
